import React from 'react';
import styles from './DashboardCard.module.css';

interface DashboardCardProps {
  title: string;
  value: React.ReactNode; /* Changed from string to React.ReactNode */
  subtitle: string;
  color?: 'green' | 'red' | 'amber' | 'blue';
}

const DashboardCard: React.FC<DashboardCardProps> = ({ title, value, subtitle, color = 'blue' }) => {
  const cardClass = `${styles.card} ${styles[color]}`;

  return (
    <div className={cardClass}>
      <h3 className={styles.title}>{title}</h3>
      <p className={`${styles.value} ${styles.fontMono}`}>{value}</p>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
};

export default DashboardCard;
